<div class="edit-document-model-container">
  <app-page-header></app-page-header>

  <!-- Page Title -->
  <div class="page-title-bar">
    <div class="page-title-wrap">
      <div class="page-title-main">
        <button
          class="title-back-btn"
          (click)="goBack()"
          [title]="backButtonTooltip"
          [attr.aria-label]="backButtonTooltip">
          <svg
            class="back-arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true">
            <path d="M19 12H5"></path>
            <path d="M12 19l-7-7 7-7"></path>
          </svg>
        </button>
        <h1 class="page-title" [title]="formatDocumentModelForDisplay(documentModel)">Fields - {{ formatDocumentModelForDisplay(documentModel) }}</h1>
      </div>

      <div class="page-title-actions">
        <div class="field-search-bar">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input type="text" [(ngModel)]="fieldSearchQuery" placeholder="Search Field Name" class="search-input" />
        </div>

        <button *ngIf="canEdit" class="add-button" (click)="addField()">
          Add Field
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="page-content">
    <!-- Table Section kept mounted so headers remain visible during load/reload transitions -->
    <div class="extraction-section">
      <!-- Progress bar shown during background refresh after save/delete -->
      <div class="reload-progress-bar" *ngIf="isLoading && fields.length > 0"></div>
      <div class="table-wrapper">
        <table class="extraction-table" [class.view-only]="!canEdit">
          <thead>
            <tr>
              <th class="col-field-name sortable" (click)="sortBy('fieldName')">
                <button type="button" class="sort-trigger" (click)="$event.stopPropagation(); sortBy('fieldName')">
                  <span>Field Name</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('fieldName')"></span>
                </button>
              </th>
              <th class="col-type sortable" (click)="sortBy('fieldType')">
                <button type="button" class="sort-trigger" (click)="$event.stopPropagation(); sortBy('fieldType')">
                  <span>Type</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('fieldType')"></span>
                </button>
              </th>
              <th class="col-feature sortable" (click)="sortBy('feature')">
                <button type="button" class="sort-trigger" (click)="$event.stopPropagation(); sortBy('feature')">
                  <span>Feature</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('feature')"></span>
                </button>
              </th>
              <th class="col-prompt">Prompt</th>
              <th class="col-addl-prompt">Additional Prompt</th>
              <th class="col-field-schema">Field Schema</th>
              <th class="col-compute-schema">Compute Schema</th>
              <th class="col-ext-key">External Key</th>
              <th class="col-modified-at sortable" (click)="sortBy('modifiedAt')">
                <button type="button" class="sort-trigger" (click)="$event.stopPropagation(); sortBy('modifiedAt')">
                  <span>Modified At</span>
                  <span class="sort-icon" [innerHTML]="getSortIcon('modifiedAt')"></span>
                </button>
              </th>
              <th class="col-actions">Actions</th>
            </tr>
          </thead>
          <tbody>
            <!-- Initial Loading State (kept inside table so headers remain visible) -->
            <tr *ngIf="isLoading && fields.length === 0">
              <td colspan="10" class="empty-search-row">
                <div class="docsila-loader">
                  <div class="beat-loader">
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                    <div class="beat"></div>
                  </div>
                  <p class="loader-text">Loading fields...</p>
                </div>
              </td>
            </tr>

            <!-- Empty State (no fields at all) -->
            <tr *ngIf="fields.length === 0 && !isLoading">
              <td colspan="10" class="empty-state">
                <p *ngIf="canEdit">No fields found. Click "Add Field" to create one.</p>
                <p *ngIf="!canEdit">No fields found.</p>
              </td>
            </tr>

            <!-- No Search Results State -->
            <tr *ngIf="hasNoSearchResults">
              <td colspan="10" class="empty-search-row">
                <div class="empty-search-state">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="11" cy="11" r="8"/>
                    <path d="m21 21-4.35-4.35"/>
                  </svg>
                  <span>No matching fields found</span>
                </div>
              </td>
            </tr>

            <!-- Field Rows -->
            <tr *ngFor="let field of fields; let i = index" [class.editing-row]="field.isEditing" [class.new-row]="field.isNew"
              [hidden]="shouldHideFieldRow(field)">

              <!-- Field Name — click opens popup for new rows -->
              <td
                class="field-name-td"
                [class.clickable-cell]="field.isNew"
                [class.always-show-badge]="field.isNew"
                [class.frozen-name-cell]="!field.isNew"
                [class.required-empty-cell]="field.isNew && !field.fieldName.trim()"
                (click)="field.isNew ? openCellPopup(i, 'fieldName') : null">
                <span class="read-only-cell truncate" [title]="field.fieldName">{{ field.fieldName || '—' }}</span>
                <span *ngIf="field.isNew" class="cell-hover-badge">
                  <svg class="badge-pencil" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/><path d="M15 5l4 4"/></svg>
                </span>
              </td>

              <!-- Field Type — native select for direct one-click open -->
              <td
                [class.clickable-cell]="canEdit"
                [class.always-show-badge]="canEdit"
                (click)="canEdit && !(inlineEditIndex === i && inlineEditColumn === 'fieldType') ? openInlineEdit(i, 'fieldType') : null">
                <span *ngIf="!canEdit" class="read-only-cell">{{ field.fieldType || '—' }}</span>
                <select *ngIf="canEdit"
                        class="cell-inline-select type-inline-select"
                        [attr.data-type]="field.fieldType"
                        [(ngModel)]="field.fieldType"
                        (focus)="openInlineEdit(i, 'fieldType')"
                        (change)="closeInlineEdit()">
                  <option *ngFor="let t of fieldTypeOptions" [value]="t">{{ t }}</option>
                </select>
              </td>

              <!-- Feature — native select for direct one-click open (same interaction as Type) -->
              <td
                [class.clickable-cell]="canEdit && !isFieldFrozen(field, 'feature')"
                [class.frozen-cell]="isFieldFrozen(field, 'feature')"
                [class.required-empty-cell]="isCellRequiredEmpty(field, 'feature')"
                (click)="canEdit && !isFieldFrozen(field, 'feature') && !(inlineEditIndex === i && inlineEditColumn === 'feature') ? openInlineEdit(i, 'feature') : null">
                <ng-container *ngIf="!canEdit || isFieldFrozen(field, 'feature')">
                  <span class="read-only-cell">{{ field.feature || '—' }}</span>
                </ng-container>
                <select *ngIf="canEdit && !isFieldFrozen(field, 'feature')"
                        class="cell-inline-select feature-inline-select"
                        [(ngModel)]="field.feature"
                        (focus)="openInlineEdit(i, 'feature')"
                        (change)="closeInlineEdit()">
                  <option value="">-- Select --</option>
                  <option *ngFor="let feat of getFeatureOptions(field.fieldType)" [value]="feat">{{ feat }}</option>
                </select>
              </td>

              <!-- Prompt — frozen for Complex -->
              <td
                [class.clickable-cell]="!isFieldFrozen(field, 'prompt')"
                [class.frozen-cell]="isFieldFrozen(field, 'prompt')"
                [class.required-empty-cell]="isCellRequiredEmpty(field, 'prompt')"
                [class.always-show-badge]="!isFieldFrozen(field, 'prompt')"
                (click)="!isFieldFrozen(field, 'prompt') ? openCellPopup(i, 'prompt') : null">
                <span class="read-only-cell truncate" [title]="field.prompt">{{ field.prompt || '—' }}</span>
                <span *ngIf="canEdit && !isFieldFrozen(field, 'prompt')" class="cell-hover-badge">
                  <svg class="badge-pencil" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/><path d="M15 5l4 4"/></svg>
                </span>
              </td>

              <!-- Additional Prompt — frozen for Simple & Complex -->
              <td
                [class.clickable-cell]="!isFieldFrozen(field, 'additionalPrompt')"
                [class.frozen-cell]="isFieldFrozen(field, 'additionalPrompt')"
                [class.required-empty-cell]="isCellRequiredEmpty(field, 'additionalPrompt')"
                [class.always-show-badge]="!isFieldFrozen(field, 'additionalPrompt')"
                (click)="!isFieldFrozen(field, 'additionalPrompt') ? openCellPopup(i, 'additionalPrompt') : null">
                <span class="read-only-cell truncate" [title]="field.additionalPrompt">{{ field.additionalPrompt || '—' }}</span>
                <span *ngIf="canEdit && !isFieldFrozen(field, 'additionalPrompt')" class="cell-hover-badge">
                  <svg class="badge-pencil" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/><path d="M15 5l4 4"/></svg>
                </span>
              </td>

              <!-- Field Schema — frozen for Simple & Array -->
              <td
                [class.clickable-cell]="!isFieldFrozen(field, 'fieldSchema')"
                [class.frozen-cell]="isFieldFrozen(field, 'fieldSchema')"
                [class.required-empty-cell]="isCellRequiredEmpty(field, 'fieldSchema')"
                [class.json-invalid-cell]="hasJsonError(i, 'fieldSchema')"
                [class.always-show-badge]="!isFieldFrozen(field, 'fieldSchema')"
                (click)="!isFieldFrozen(field, 'fieldSchema') ? openCellPopup(i, 'fieldSchema') : null">
                <div class="schema-hover-wrapper"
                  (mouseenter)="showSchemaTooltip(i, $event)"
                  (mouseleave)="hideSchemaTooltip()"
                  (click)="$event.stopPropagation()">
                  <span class="read-only-cell truncate" (click)="!isFieldFrozen(field, 'fieldSchema') ? openCellPopup(i, 'fieldSchema') : null">{{ field.fieldSchema || '—' }}</span>
                  <div class="json-tooltip schema-hover-tooltip" *ngIf="hoveredSchemaIndex === i && field.fieldSchema" [style.top.px]="schemaTooltipPos.top" [style.left.px]="schemaTooltipPos.left" [class.tooltip-up]="schemaTooltipPos.up" [class.tooltip-down]="!schemaTooltipPos.up" (click)="$event.stopPropagation()">
                    <pre>{{ formatJsonForTooltip(field.fieldSchema) }}</pre>
                  </div>
                </div>
                <span *ngIf="canEdit && !isFieldFrozen(field, 'fieldSchema')" class="cell-hover-badge">
                  <svg class="badge-pencil" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/><path d="M15 5l4 4"/></svg>
                </span>
              </td>

              <!-- Compute Schema — frozen for Simple & Array -->
              <td
                [class.clickable-cell]="!isFieldFrozen(field, 'computeSchema')"
                [class.frozen-cell]="isFieldFrozen(field, 'computeSchema')"
                [class.required-empty-cell]="isCellRequiredEmpty(field, 'computeSchema')"
                [class.json-invalid-cell]="hasJsonError(i, 'computeSchema')"
                [class.always-show-badge]="!isFieldFrozen(field, 'computeSchema')"
                (click)="!isFieldFrozen(field, 'computeSchema') ? openCellPopup(i, 'computeSchema') : null">
                <div class="schema-hover-wrapper"
                  (mouseenter)="showComputeSchemaTooltip(i, $event)"
                  (mouseleave)="hideComputeSchemaTooltip()"
                  (click)="$event.stopPropagation()">
                  <span class="read-only-cell truncate" (click)="!isFieldFrozen(field, 'computeSchema') ? openCellPopup(i, 'computeSchema') : null">{{ field.computeSchema || '—' }}</span>
                  <div class="json-tooltip schema-hover-tooltip" *ngIf="hoveredComputeSchemaIndex === i && field.computeSchema" [style.top.px]="computeSchemaTooltipPos.top" [style.left.px]="computeSchemaTooltipPos.left" [class.tooltip-up]="computeSchemaTooltipPos.up" [class.tooltip-down]="!computeSchemaTooltipPos.up" (click)="$event.stopPropagation()">
                    <pre>{{ formatJsonForTooltip(field.computeSchema) }}</pre>
                  </div>
                </div>
                <span *ngIf="canEdit && !isFieldFrozen(field, 'computeSchema')" class="cell-hover-badge">
                  <svg class="badge-pencil" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/><path d="M15 5l4 4"/></svg>
                </span>
              </td>

              <!-- External Key -->
              <td
                [class.clickable-cell]="!isFieldFrozen(field, 'externalKey')"
                [class.frozen-cell]="isFieldFrozen(field, 'externalKey')"
                (click)="!isFieldFrozen(field, 'externalKey') ? openCellPopup(i, 'externalKey') : null">
                <span class="read-only-cell">{{ field.externalKey || '—' }}</span>
                <span *ngIf="canEdit && !isFieldFrozen(field, 'externalKey')" class="cell-hover-badge">
                  <svg class="badge-pencil" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/><path d="M15 5l4 4"/></svg>
                </span>
              </td>

              <!-- Modified At -->
              <td>
                <div class="modified-at-cell" *ngIf="field.modifiedAt">
                  <span class="modified-date">{{ field.modifiedAt | date:'dd MMM yy' }}</span>
                  <span class="modified-time">{{ field.modifiedAt | date:'h:mm a' }}</span>
                </div>
                <span *ngIf="!field.modifiedAt" class="read-only-cell">—</span>
              </td>

              <!-- Actions -->
              <td class="actions-cell">
                <div *ngIf="!field.isEditing && canEdit" class="action-buttons">
                  <button class="action-btn-icon delete-btn" (click)="deleteField(i)" title="Delete">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="3 6 5 6 21 6"/>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    </svg>
                  </button>
                </div>
                <div *ngIf="field.isEditing" class="action-buttons">
                  <button class="action-btn-icon save-btn" (click)="saveField(i)" title="Save" [disabled]="!hasFieldChanged(i) || !isFieldValid(i) || isSubmitting">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </button>
                  <button class="action-btn-icon cancel-btn" (click)="cancelEdit(i)" title="Cancel">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                      <line x1="18" y1="6" x2="6" y2="18"/>
                      <line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

  <!-- Cell Edit Popup -->
  <div class="cell-popup-overlay" *ngIf="editPopupIndex >= 0">
    <div class="cell-popup-card" (click)="$event.stopPropagation()">

      <!-- Header: field context + toolbar buttons -->
      <div class="cell-popup-header">
        <span class="popup-field-context"
              [title]="(fields[editPopupIndex]?.fieldName || 'New Field') + ' · ' + getColumnLabel(editPopupColumn)">
          {{ fields[editPopupIndex]?.fieldName || 'New Field' }}
        </span>
        <span class="popup-col-label">{{ getColumnLabel(editPopupColumn) }}</span>
        <div class="popup-header-toolbar">
          <button *ngIf="canEdit" class="popup-tool-btn" type="button" (click)="undoPopupCell()" title="Undo changes to this field">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"/>
            </svg>
            Undo
          </button>
          <button *ngIf="canEdit" class="popup-tool-btn popup-tool-clear" type="button" (click)="clearPopupCell()" title="Clear this field">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
            Clear
          </button>
          <button class="popup-tool-btn popup-tool-copy" type="button" (click)="copyPopupCell()" title="Copy this field value">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
            </svg>
            Copy
          </button>
        </div>
      </div>

      <!-- Body: one field at a time -->
      <div class="cell-popup-body" *ngIf="editPopupIndex >= 0 && fields[editPopupIndex]">
        <ng-container [ngSwitch]="editPopupColumn">

          <!-- Field Name -->
          <ng-container *ngSwitchCase="'fieldName'">
            <input
              type="text"
              class="popup-input"
              [class.json-error-field]="isPopupFieldNameDuplicate"
              placeholder="Enter field name"
              [(ngModel)]="fields[editPopupIndex].fieldName"
              [readonly]="!canEdit || !fields[editPopupIndex].isNew"
              [class.field-readonly]="!canEdit || !fields[editPopupIndex].isNew"
            />
            <p *ngIf="isPopupFieldNameDuplicate" class="popup-json-error-msg">⚠ A field with this name already exists</p>
            <p *ngIf="!fields[editPopupIndex].isNew" class="popup-hint">Field name cannot be changed for existing fields.</p>
          </ng-container>

          <!-- Field Type -->
          <ng-container *ngSwitchCase="'fieldType'">
            <select class="popup-select" [(ngModel)]="fields[editPopupIndex].fieldType">
              <option *ngFor="let type of fieldTypeOptions" [value]="type">{{ type }}</option>
            </select>
          </ng-container>

          <!-- Feature -->
          <ng-container *ngSwitchCase="'feature'">
            <select
              class="popup-select"
              [(ngModel)]="fields[editPopupIndex].feature"
              [disabled]="isFieldFrozen(fields[editPopupIndex], 'feature')"
            >
              <option value="">-- Select Feature --</option>
              <option
                *ngIf="fields[editPopupIndex].feature && !getFeatureOptions(fields[editPopupIndex].fieldType).includes(fields[editPopupIndex].feature)"
                [value]="fields[editPopupIndex].feature"
              >{{ fields[editPopupIndex].feature }}</option>
              <option *ngFor="let feat of getFeatureOptions(fields[editPopupIndex].fieldType)" [value]="feat">{{ feat }}</option>
            </select>
            <p *ngIf="isFieldFrozen(fields[editPopupIndex], 'feature')" class="popup-hint">Feature is not applicable for {{ fields[editPopupIndex].fieldType }} fields.</p>
          </ng-container>

          <!-- Prompt -->
          <ng-container *ngSwitchCase="'prompt'">
            <textarea
              class="popup-textarea"
              rows="8"
              placeholder="Enter prompt text…"
              [(ngModel)]="fields[editPopupIndex].prompt"
              [readonly]="!canEdit"
              [disabled]="isFieldFrozen(fields[editPopupIndex], 'prompt')"
            ></textarea>
            <p *ngIf="isFieldFrozen(fields[editPopupIndex], 'prompt')" class="popup-hint">Prompt is not applicable for {{ fields[editPopupIndex].fieldType }} fields.</p>
          </ng-container>

          <!-- Additional Prompt -->
          <ng-container *ngSwitchCase="'additionalPrompt'">
            <textarea
              class="popup-textarea"
              rows="8"
              placeholder="Enter additional prompt text…"
              [(ngModel)]="fields[editPopupIndex].additionalPrompt"
              [readonly]="!canEdit"
              [disabled]="isFieldFrozen(fields[editPopupIndex], 'additionalPrompt')"
            ></textarea>
            <p *ngIf="isFieldFrozen(fields[editPopupIndex], 'additionalPrompt')" class="popup-hint">Additional Prompt is not applicable for {{ fields[editPopupIndex].fieldType }} fields.</p>
          </ng-container>

          <!-- Field Schema -->
          <ng-container *ngSwitchCase="'fieldSchema'">
            <textarea
              class="popup-textarea"
              [class.json-error-field]="hasJsonError(editPopupIndex, 'fieldSchema')"
              rows="8"
              placeholder="Field Schema (JSON)"
              [(ngModel)]="fields[editPopupIndex].fieldSchema"
              [readonly]="!canEdit"
              [disabled]="isFieldFrozen(fields[editPopupIndex], 'fieldSchema')"
              (ngModelChange)="onPopupSchemaInputChange('fieldSchema')"
              (blur)="validateJsonField(editPopupIndex, 'fieldSchema')"
            ></textarea>
            <p *ngIf="hasJsonError(editPopupIndex, 'fieldSchema')" class="popup-json-error-msg">⚠ Invalid JSON</p>
            <p *ngIf="isFieldFrozen(fields[editPopupIndex], 'fieldSchema')" class="popup-hint">Field Schema is not applicable for {{ fields[editPopupIndex].fieldType }} fields.</p>
            <ng-container *ngIf="canEdit && fields[editPopupIndex].fieldType === 'Complex'">
              <input #fsFileInput type="file" accept=".json"
                     (change)="handleJsonUpload(editPopupIndex, $event)"
                     style="display:none" />
              <button type="button"
                      class="popup-upload-label"
                      [class.popup-upload-label--loading]="isJsonUploading"
                      [disabled]="isJsonUploading"
                      (click)="startJsonUpload(fsFileInput, $event)">
                <span class="upload-btn-idle" [hidden]="isJsonUploading">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" y1="3" x2="12" y2="15"/>
                  </svg>
                  Upload JSON
                </span>
                <span class="upload-btn-loading" [hidden]="!isJsonUploading">
                  <span class="popup-upload-spinner"></span>
                  Uploading…
                </span>
              </button>
            </ng-container>
          </ng-container>

          <!-- Compute Schema -->
          <ng-container *ngSwitchCase="'computeSchema'">
            <textarea
              class="popup-textarea"
              [class.json-error-field]="hasJsonError(editPopupIndex, 'computeSchema')"
              rows="8"
              placeholder="Compute Schema (JSON)"
              [(ngModel)]="fields[editPopupIndex].computeSchema"
              [readonly]="!canEdit"
              [disabled]="isFieldFrozen(fields[editPopupIndex], 'computeSchema')"
              (ngModelChange)="onPopupSchemaInputChange('computeSchema')"
              (blur)="validateJsonField(editPopupIndex, 'computeSchema')"
            ></textarea>
            <p *ngIf="hasJsonError(editPopupIndex, 'computeSchema')" class="popup-json-error-msg">⚠ Invalid JSON</p>
            <!-- Upload JSON for Complex and Compute fields -->
            <ng-container *ngIf="canEdit && (fields[editPopupIndex].fieldType === 'Complex' || fields[editPopupIndex].fieldType === 'Compute')">
              <input #csFileInput type="file" accept=".json"
                     (change)="handleJsonUpload(editPopupIndex, $event)"
                     style="display:none" />
              <button type="button"
                      class="popup-upload-label"
                      [class.popup-upload-label--loading]="isJsonUploading"
                      [disabled]="isJsonUploading"
                      (click)="startJsonUpload(csFileInput, $event)">
                <span class="upload-btn-idle" [hidden]="isJsonUploading">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" y1="3" x2="12" y2="15"/>
                  </svg>
                  Upload JSON
                </span>
                <span class="upload-btn-loading" [hidden]="!isJsonUploading">
                  <span class="popup-upload-spinner"></span>
                  Uploading…
                </span>
              </button>
            </ng-container>
          </ng-container>

          <!-- External Key -->
          <ng-container *ngSwitchCase="'externalKey'">
            <input
              type="text"
              class="popup-input"
              placeholder="External Key"
              [(ngModel)]="fields[editPopupIndex].externalKey"
              [readonly]="!canEdit"
              [disabled]="fields[editPopupIndex].fieldType === 'Complex'"
            />
            <p *ngIf="fields[editPopupIndex].fieldType === 'Complex'" class="popup-hint">External Key is not applicable for Complex fields.</p>
          </ng-container>

        </ng-container>
      </div>

      <!-- Footer: Cancel + Done buttons -->
      <div class="popup-footer">
        <button *ngIf="!canEdit" class="popup-done-btn" type="button" (click)="cancelPopup()">Close</button>
        <button *ngIf="canEdit" class="popup-cancel-btn" type="button" (click)="cancelPopup()">Cancel</button>
        <button *ngIf="canEdit" class="popup-done-btn" type="button" (click)="closePopup()" [disabled]="isPopupDoneDisabled">Done</button>
      </div>

    </div>
  </div>

  <!-- Confirmation Modal -->
  <div class="confirm-overlay" *ngIf="showConfirmModal" (click)="cancelConfirm()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <h3 class="confirm-title">
        <span *ngIf="confirmAction === 'delete'">Confirm Delete</span>
        <span *ngIf="confirmAction === 'create'">Confirm Add Field</span>
        <span *ngIf="confirmAction === 'update'">Save Changes</span>
      </h3>
      <p class="confirm-message">{{ confirmMessage }}</p>
      <div *ngIf="confirmAction === 'update'" class="change-reason-input">
        <label class="reason-label">Reason for Change <span class="reason-required">*</span></label>
        <textarea
          [(ngModel)]="changeReason"
          placeholder="Enter reason for change (required)"
          rows="3"
          class="reason-textarea"
        ></textarea>
      </div>
      <div class="confirm-buttons">
        <button class="btn-no" (click)="cancelConfirm()">Cancel</button>
        <button *ngIf="confirmAction === 'delete'" class="btn-yes btn-danger" (click)="executeConfirm()">Yes, Delete</button>
        <button *ngIf="confirmAction === 'create'" class="btn-yes" (click)="executeConfirm()">Yes, Add</button>
        <button *ngIf="confirmAction === 'update'" class="btn-yes" [disabled]="!changeReason.trim()" (click)="executeConfirm()">Save</button>
      </div>
    </div>
  </div>

  <!-- Unsaved Changes Modal -->
  <div class="unsaved-modal-overlay" *ngIf="showUnsavedModal" (click)="unsavedDontSave()">
    <div class="unsaved-modal-card" (click)="$event.stopPropagation()">
      <div class="unsaved-modal-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#5b6cf2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h3 class="unsaved-modal-title">Unsaved Changes</h3>
      <p class="unsaved-modal-message">Do you want to save changes?</p>
      <div class="unsaved-modal-buttons">
        <button class="unsaved-btn unsaved-btn-discard" (click)="unsavedDontSave()">No</button>
        <button class="unsaved-btn unsaved-btn-save" (click)="unsavedSaveAndLeave()">Yes</button>
      </div>
    </div>
  </div>
</div>

